import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux";
import { showToast, startLoader, stopLoader } from "../../../lib/global";
import { deleteCollectionById } from "../../../redux/actions/collections.action";

const DeleteCollectionModal = (props) => {
  const dispatch = useDispatch();

  const deleteFun = () => {
    startLoader();
    dispatch(deleteCollectionById(props.id))
      .then((res) => {
        setTimeout(() => {
          stopLoader();
          if (res?.data?.status === 200) {
            showToast("Collection deleted successfully", "success");
            if (props.onSubmit) {
              props.onSubmit();
            }
          } else {
            showToast(res?.data?.message || "Failed to delete collection", "error");
          }
        }, 500);
        props.onClose();
      })
      .catch(() => {
        stopLoader();
        props.onClose();
        showToast("Failed to delete collection", "error");
      });
  };

  return (
    <React.Fragment>
      <div className="delete_modal_body">
        <div className="close_icon" style={{ top: "0px" }}>
          <CloseIcon
            className="close_icon_btn m-2"
            color="primary2"
            fontSize="large"
            title="Close dialog"
            onClick={props.onClose}
          />
        </div>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="confirmation_dialogbox__content">
            <div className="dialogbox_body__content">
              <h1 className="d-flex flex-direction-row justify-content-center align-items-center">
                <span className="dialogbox_header__icon">!</span>
              </h1>
              <h4>Are you sure you want to delete?</h4>
              <p>
                Deleting this collection removes product assignments and discount links to it.
                <br />
                You are unable to restore it back again.
              </p>
            </div>
          </div>
        </div>
        <div className="dialogbox_footer__content">
          <button type="button" className="dialogbox_delete__btn" onClick={deleteFun}>
            Delete
          </button>
          <button type="button" className="dialogbox_cancel__btn" onClick={props.onClose}>
            Cancel
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DeleteCollectionModal;
